<template>
  <div>
    <!-- Form -->
    <v-card>
      <v-card-title>
        <v-layout row wrap>
          <v-flex xs12 sm6 md8> 
            <span class="headline">{{ formTitle }}</span>
          </v-flex>
          <v-flex xs12 sm6 md4> 
            <span class="headline">Project Budget Information</span>
          </v-flex>
        </v-layout>              
      </v-card-title>

      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text class="pt-0">
          <v-container grid-list-md>
            <v-layout row wrap>
            <v-flex xs12 sm6 md8> 
              <v-layout row wrap>
                <v-flex xs12 sm6 md6>              
                  <!-- return-object   -->
                  <v-autocomplete
                  v-model="formSchema.eco_code"
                  :items="ecoCodeList"
                  :loading="isLoading"          
                  item-text="eco_account_code"
                  item-value="ecoAccount_code"
                  label="Economic Code *"                         
                  :rules="[v => !!v || 'Economic code is required !']"
                  required
                  @change="onChangeEcoCode(formSchema.eco_code)"
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field
                  label="Economic Code Name *"
                  v-model="formSchema.account_name"
                  :rules="[v => !!v || 'Economic code name is required !']"
                  required                  
                  ></v-text-field>
                </v-flex>

              <v-flex xs12 sm6 md6>
                <v-autocomplete
                label="Unit *"
                item-text="name"
                item-value="id"
                v-model="formSchema.unit"
                :items="unitList"
                :rules="[v => !!v || 'Unit is required !']"
                required
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                label="Quantity"
                v-model="formSchema.quantity"
                :rules="[number, lng6]"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                label="GoB Amount"
                v-model="formSchema.gob_amount"
                :rules="[decimal]"
                @input="totalAmount"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                label="RPA Amount"
                v-model="formSchema.ida_amount"
                :rules="[decimal]"
                @input="totalAmount"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                label="Total Amount"
                v-model="formSchema.total"
                readonly
                ></v-text-field>
              </v-flex>
              

             <!--  <v-flex xs12 sm6 md6>
                <DatePicker
                  :key="formSchema.id"
                  :inputData="{index:1,fieldName:'date', fieldValue:formSchema.date, label:'Start Date',required:1}"
                  @setValue="setDateValue"
                ></DatePicker>
              </v-flex> -->

              <v-flex xs12 sm6 md6 >
                <v-checkbox v-model="formSchema.is_active" label="Active" :value="is_activeVal"></v-checkbox>
              </v-flex>

              <v-flex xs12 sm6 md6 v-if="formSchema.revision>0">
                <v-textarea label="Remarks" v-model="formSchema.remarks">></v-textarea>
              </v-flex>

              <v-flex xs12 sm6 md12 >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
                    <v-icon>save</v-icon>
                    {{addUpdateBtn}}
                  </v-btn>
                  <v-btn color="error" @click.native="$refs.form.reset" @click="resetForm">
                    <v-icon>refresh</v-icon>Reset
                  </v-btn>
                </v-card-actions>
              </v-flex>


            </v-layout>
            </v-flex>

            <v-flex xs12 sm6 md4 style="border:1px solid #CCC; text-align:center">                                           
              Document Name :  {{proBudgetInfo.document_name}}<br>
              Budget Date :  {{changeFormateDMY(proBudgetInfo.budget_date)}}<br>
              File :  <!-- {{proBudgetInfo.document_file_name}} -->
                <a
                target="_blank"
                v-if="proBudgetInfo.document_file_name"
                title="Download"
                :href="`${public_path}${proBudgetInfo.document_file_name}`"
                download
                >
                <v-icon v style="vertical-align:top; font-size:30px;">cloud_download</v-icon>
              </a>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>      
    </v-form>
  </v-card>
  <!-- /Form -->
</div>
</template>


<script>
let commonService = require("../../../../services/common.service");
import DatePicker from "../../../global/date_picker";
import ServerPath from "../../../../server-path/server-path";

export default {
  props: ["formSchema"],
  components: {
    DatePicker
  },
  data: () => ({
    valid: true,
    public_path: ServerPath.serverPath,
    is_activeVal: 1,

    isLoading: false,

    proBudgetInfo:{
      log_in_project_id:'',
      budget_date:'',
      document_name:'',
      upload_file_name:'',
      is_active:''
    },
    unitList:[],
    ecoCodeList:[],
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0 ? 
      this.formSchema.revision > 0 ? "Revision Project Budget Details" : 
      "Edit Project Budget Details" : 
      "Add Project Budget Details";
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? this.formSchema.revision > 0 ? "Revision" : "Update" : "Save";
    }

  },

  created() {
    //sessionStorage.removeItem('revision')  

    let proId = sessionStorage.getItem("proId"); 
    let mulParam = {'proId': proId, 'rootNameWise':0};

    commonService.dataByMulParameters(mulParam, "get-pro-budDet-dropdown-data").then(res => {
        this.ecoCodeList = res.ecoCodeList;
        this.unitList = res.unitList;
        this.proBudgetInfo = res.proBudgetInfo
    });    

  },

  methods: {

    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
    },

    validateBeforeSubmit(e) {
      var formSchema = {...this.formSchema};

      formSchema.proj_budget_id = sessionStorage.getItem("proId");
      /*formSchema.date = this.changeFormateYMD(
          formSchema.date
        );*/ 


      if (this.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService.updateFormData(formSchema, "project-budget-detail").then(res => {
            let actionData = {
              message: res.message,
              data: res.data,
              action: "edit",
              revision: res.revision,
              status: res.status
            };
            this.close(actionData);
          });
        } else {
          commonService.insertFormData(formSchema, "project-budget-detail").then(res => {
            let actionData = {
              message: res.message,
              data: res.data,
              action: "add",
              revision: res.revision,
              status: res.status
            };
            this.close(actionData);
          });
        }
      }      
    },

    totalAmount(){
      let formSchema = this.formSchema;
      let gob_amount = (formSchema.gob_amount>0) ? parseFloat(formSchema.gob_amount) : 0;
      let ida_amount = (formSchema.ida_amount>0) ? parseFloat(formSchema.ida_amount) : 0;
      formSchema.total = (gob_amount + ida_amount).toFixed(3);
    },

    onChangeEcoCode(eco_code)
    {      
      //console.log('value = ', eco_code)
      let ecoCode = '';
      if (eco_code) {
        ecoCode = this.ecoCodeList.filter(function(a) {
          return a.ecoAccount_code == eco_code;
        })[0].eco_account_name;
      }
      this.formSchema.account_name = ecoCode
    },

    resetForm(){
      this.formSchema.id = 0;
    },

    close: function(data) {
      if (data.status == 1) {
        this.formSchema.id = 0;
        this.$refs.form.reset();
      }
      this.$emit("emitForm", data);
    }
  }
};
</script>

<style scoped>
  .proTitle {
    color: #FFFFD8;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    background: #388e3c;
  }
</style>


// WEBPACK FOOTER //
// src/components/project_info/project_budget/prject_bud_details/insertForm.vue